import styled from "styled-components";
//dls
import { Text } from "@swiggy-private/dls-web-core/dist/components/Text";
import { Image } from "@swiggy-private/dls-web-core/dist/components/Image";

export const Container = styled.div(({ theme }) => {
    return {
        position: "fixed",
        bottom: 0,
        left: 0,
        right: 0,
        backgroundColor: theme.colors[theme.colorMode].background_Primary,
        boxShadow: theme.elevation[theme.colorMode].floating.boxShadow,
        zIndex: theme.elevation[theme.colorMode].skim.zIndex,
    };
});

export const SavingsCallout = styled.div(({ theme }) => {
    return {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "#E5FFF4", // unavailable token in dls-web-theme
        border: `4px solid ${theme.colors[theme.colorMode].background_Primary}`,
    };
});

export const StyledText = styled(Text)(({ theme }) => {
    return {
        padding: `${theme.spacing.xSmall} 0`,
    };
});

export const CTAContainer = styled.div(({ theme }) => {
    return {
        padding: `calc(${theme.spacing.xSmall} + ${theme.spacing.xxxSmall}) ${theme.spacing.medium} ${theme.spacing.large}`,
        paddingBottom: `calc(${theme.spacing.large} + var(--sab, 0px))`,
    };
});

export const IconWrapper = styled(Image)<{ leftIcon?: boolean; rightIcon?: boolean }>(
    ({ theme, leftIcon, rightIcon }) => {
        return {
            ...(leftIcon && {
                marginRight: theme.spacing.xxxSmall,
            }),
            ...(rightIcon && {
                marginLeft: theme.spacing.xxxSmall,
            }),
        };
    },
);
